const getItemStorage = (keyName) => {
  return sessionStorage.getItem(keyName);
}

export default getItemStorage;
